import {
  initPaymentFailAction,
  pay3dsFailAction,
  payUnitellerFailAction,
} from 'src/store/payment/reducer';
import { createCertificateFailedAction } from './store/certificate/sagaActions';

export const CERTIFICATE_ANALYTICS_EVENT_NAMES = {
  CERTIFICATE_CREATION_FAILED: 'certificate_creation_failed',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_STARTED: 'payment_started',
} as const;

export const CERTIFICATE_EVENTS_TO_ANALYTICS_EVENTS = {
  [createCertificateFailedAction.type]:
    CERTIFICATE_ANALYTICS_EVENT_NAMES.CERTIFICATE_CREATION_FAILED,
  [initPaymentFailAction.type]:
    CERTIFICATE_ANALYTICS_EVENT_NAMES.CERTIFICATE_CREATION_FAILED,
  [payUnitellerFailAction.type]:
    CERTIFICATE_ANALYTICS_EVENT_NAMES.PAYMENT_FAILED,
  [pay3dsFailAction.type]: CERTIFICATE_ANALYTICS_EVENT_NAMES.PAYMENT_FAILED,
};
